import { SocialNetworksModel } from './social-networks.model';
import { AddressModel } from './address.model';
import { AuthModel } from './auth.model';
import { UserModel } from './user.model'

export default {
    UserModel,
    AuthModel,
    AddressModel,
    SocialNetworksModel
}